import { ILocalStorage } from './driver'
import { CredentialsStorage } from './names'

export default function() {
  return function(ls: ILocalStorage): ILocalStorage {
    return {
      clear(): void {
        return ls.clear()
      },
      getItem(key: string, ifEmpty: string): string {
        const username = ls.getItem(CredentialsStorage.UserID, '')
        const userKey = `${username}_${key}`

        return ls.getItem(userKey, ifEmpty)
      },
      key(index: number): string | null {
        return ls.key(index)
      },
      removeItem(key: string): void {
        const username = ls.getItem(CredentialsStorage.UserID, '')
        const userKey = `${username}_${key}`

        return ls.removeItem(userKey)
      },
      setItem(key: string, value: string): void {
        const username = ls.getItem(CredentialsStorage.UserID, '')
        const userKey = `${username}_${key}`

        return ls.setItem(userKey, value)
      },
    }
  }
}
